import React from "react";
import Link from "next/link";
import Head from "next/head";
import Image from "next/image";
import { BsPencilSquare } from "react-icons/bs";
import { AiOutlineFontSize } from "react-icons/ai";
import CtaOne from "@components/CTA/CtaOne";
import { CLMButtonPrimary } from "components/CLM/v3/Buttons";
import { BASE_ASSETS_URL } from "@constants/constants";
const SignatureTool = () => {
  return (
    <div className="w-full mt-12 md:mt-20">
      <Head>
        <title>
          BoloForms Signature Tool - Create Digital Signatures with Ease
        </title>
        <meta
          name="description"
          content="BoloForms Signature Tool - Create your unique digital signature with ease. Use our advanced features to draw your signature or manually select a signature font. Perfect for documents, contracts, and more."
        />
        <meta
          name="keywords"
          content="signature tool, signature generator, online signature, digital signature, e-signature, signature maker, signature creator, signature font, signature fonts, signature generator online, signature generator free, signature generator free online, signature generator free downlo"
        />
        <meta name="generator" content="BoloForms Signature Tool" />
        <meta
          property="og:title"
          content="BoloForms Signature Tool - Create Digital Signatures with Ease"
        />
        <meta
          property="og:description"
          content="BoloForms Signature Tool allows you to create your unique digital signature effortlessly. Draw your signature or choose from a selection of signature fonts. Ideal for documents, contracts, and more."
        />
        <meta
          property="og:url"
          content="https://www.bolosign.com/signature/online-signature/"
        />
        <meta property="og:type" content="website" />
        <meta
          name="robots"
          content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
        />
        <link
          rel="canonical"
          href="https://www.bolosign.com/signature/online-signature/"
        />
      </Head>

      <div className="flex flex-col max-w-[1280px] gap-2 md:gap-16 mx-auto px-4 md:px-8">
        <div className="flex flex-col justify-center items-center text-center">
          <div className="max-w-screen-md mx-auto text-center relative">
            <p className="text-[17px] md:text-[20px] text-violet-800 mb-2">
              Create and download your free e-signature
            </p>
            <CtaOne
              heading2="Online Signature Generator"
              paragraph="An online signature generator/maker is a tool that helps you create an online signature. eSignatures are a fast and easy way to sign contracts and legal documents."
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-center items-center gap-[30px]">
          <div className="sm:w-[500px] sm:h-[400px] bg-cream text-black text-center flex flex-col justify-between gap-[50px] sm:gap-[10px] px-[20px] py-[30px] lg:py-[40px] lg:px-[50px] rounded-xl border border-gray-300">
            <div className="h-full flex flex-col gap-[15px]">
              <div className="bg-cream rounded-xl px-4 flex items-center justify-center">
                <Image
                  src={`${BASE_ASSETS_URL}/v2/clm/online-signature-maker/draw-signature.png`}
                  // src={require(`assets/signature/online-signature-maker/draw-signature.png`)}
                  alt={"Draw Signature"}
                  width={150}
                  height={150}
                  className="h-24 sm:h-28 w-auto"
                />
              </div>
              <div className="h-full flex flex-col justify-between gap-4">
                <div className="flex-1">
                  <div className="text-[20px] sm:text-[25px] font-bold">
                    Draw your Signature
                  </div>
                  <div className="text-base font-medium">
                    Go artistic. Use your mouse or trackpad to make a statement.
                  </div>
                </div>
                <CLMButtonPrimary
                  buttonText="Draw your signature"
                  buttonUrl="/signature/online-signature/draw"
                />
              </div>
            </div>
          </div>
          <div className="sm:w-[500px] sm:h-[400px] bg-cream text-black text-center flex flex-col justify-between gap-[50px] sm:gap-[10px] px-[20px] py-[30px] lg:py-[40px] lg:px-[50px] rounded-xl border border-gray-300">
            <div className="h-full flex flex-col gap-[15px]">
              <div className="bg-cream rounded-xl px-4 flex items-center justify-center">
                <Image
                  // src={`${BASE_ASSETS_URL}/signature/online-signature-maker/type-signature.png`}
                  src={require(
                    `assets/signature/online-signature-maker/type-signature.png`,
                  )}
                  alt={"Type Signature"}
                  width={150}
                  height={150}
                  className="h-24 sm:h-28 w-auto"
                />
              </div>
              <div className="h-full flex flex-col justify-between gap-4">
                <div className="flex-1">
                  <div className="text-[20px] sm:text-[25px] font-bold">
                    Type your Signature
                  </div>
                  <div className="text-base font-medium">
                    So many choices. Type your name and choose the font that
                    best matches your personality.
                  </div>
                </div>
                <CLMButtonPrimary
                  buttonText="Type your signature"
                  buttonUrl="/signature/online-signature/type"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignatureTool;
